/* eslint-disable no-unused-vars */
import { call, put, select, take, takeEvery } from "redux-saga/effects";
import { api } from "Shared/axios";
import { getReqHeader } from "Shared/helpers";
import { selectPayHistory } from "./payhistory.select";
import { payHistoryActions } from "./payhistory.slice";

function* historyRequest() {
	try {
		const params = yield select(selectPayHistory.params);
		const headers = yield call(getReqHeader);
		const { data } = yield call(api.get, "/payment/user-history", { ...headers, params });
		yield put(payHistoryActions.set(data));
	} catch (error) {
		console.error(error);
	}
}

export function* watchPayHistory() {
	yield takeEvery(payHistoryActions.get, historyRequest);
	yield takeEvery(payHistoryActions.changePage, historyRequest);
}
